import { css } from '@emotion/core';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';
import {
  linkBaseCss,
  redTextCss,
  redUnderlineCss,
} from '../CtaLink/index.styles';

export const richTextCss = css(typography.effra18, {
  p: {
    marginBottom: 30,
    '&:last-child': {
      marginBottom: 0,
    },
  },
  ul: {
    marginBottom: 30,
    '&:last-child': {
      marginBottom: 0,
    },
    li: {
      lineHeight: '2.11',

      '&:before': {
        content: '"•"',
        color: colorsPalette.black,
        display: 'inline-block',
        marginRight: 13,
      },
    },
  },
  strong: {
    fontWeight: fontWeights.medium,
    color: colorsPalette.black,
  },
  a: [linkBaseCss, redTextCss, redUnderlineCss],
});
